"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Reflector_1 = __importDefault(require("../Reflector"));
function Property(schemaObj) {
    return (target, propertyName) => {
        if ((typeof schemaObj === 'object') && (typeof schemaObj.format === 'undefined')) {
            const tsType = Reflector_1.default.getTsType(target, propertyName);
            if (tsType) {
                schemaObj.format = tsType;
            }
        }
        Reflector_1.default.setConvictMetaForProperty(schemaObj, target, propertyName);
        Reflector_1.default.setPropertyForClass(target, propertyName);
    };
}
exports.Property = Property;
